function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import { isNumber } from 'vega-util';
import { hasProperty, keys } from '../util';
import { isConcatSpec, isVConcatSpec } from './concat';
import { isFacetMapping, isFacetSpec } from './facet';
export function getStepFor(_ref) {
  var step = _ref.step,
    offsetIsDiscrete = _ref.offsetIsDiscrete;
  if (offsetIsDiscrete) {
    var _step$for;
    return (_step$for = step.for) !== null && _step$for !== void 0 ? _step$for : 'offset';
  } else {
    return 'position';
  }
}
export function isStep(size) {
  return hasProperty(size, 'step');
}
export function isFrameMixins(o) {
  return hasProperty(o, 'view') || hasProperty(o, 'width') || hasProperty(o, 'height');
}
export var DEFAULT_SPACING = 20;
var COMPOSITION_LAYOUT_INDEX = {
  align: 1,
  bounds: 1,
  center: 1,
  columns: 1,
  spacing: 1
};
var COMPOSITION_LAYOUT_PROPERTIES = keys(COMPOSITION_LAYOUT_INDEX);
export function extractCompositionLayout(spec, specType, config) {
  var compositionConfig = config[specType];
  var layout = {};
  // Apply config first
  var spacingConfig = compositionConfig.spacing,
    columns = compositionConfig.columns;
  if (spacingConfig !== undefined) {
    layout.spacing = spacingConfig;
  }
  if (columns !== undefined) {
    if (isFacetSpec(spec) && !isFacetMapping(spec.facet) || isConcatSpec(spec)) {
      layout.columns = columns;
    }
  }
  if (isVConcatSpec(spec)) {
    layout.columns = 1;
  }
  // Then copy properties from the spec
  var _iterator = _createForOfIteratorHelper(COMPOSITION_LAYOUT_PROPERTIES),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var prop = _step.value;
      if (spec[prop] !== undefined) {
        if (prop === 'spacing') {
          var _spacing$row, _spacing$column;
          var spacing = spec[prop];
          layout[prop] = isNumber(spacing) ? spacing : {
            row: (_spacing$row = spacing.row) !== null && _spacing$row !== void 0 ? _spacing$row : spacingConfig,
            column: (_spacing$column = spacing.column) !== null && _spacing$column !== void 0 ? _spacing$column : spacingConfig
          };
        } else {
          layout[prop] = spec[prop];
        }
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return layout;
}